import { getAPIFromDomain } from "../../lib/api";

export interface WarehouseLog {
  source_platform: string;
  event_name: string;
  input_resource: string;
  created_at: string;
  organization_id: string;
  data: WarehouseLogData;
}

export interface WarehouseLogData {
  id: string;
  product: { sku: string; upc: string; lot_number: string; serial_number: string };
  facility: string;
  quantity: number;
  physical_stock_count_change: number;
  from_status: null;
  to_status: string;
  reference_number: string;
  reason_code: string;
}

export const fetchWarehouseProductLogs = async (payload: unknown): Promise<WarehouseLog[]> => {
  const api = getAPIFromDomain("november");
  const res = await api.post(`/reporting/retrieve-event-logs-for-external`, payload);
  return res.data;
};
